import { useBuilderConfigContext } from 'hb-builder/hooks';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';

import ColorSetting from '../CommonSettings/ColorSetting';
import FontFamily from '../CommonSettings/FontFamily';
import FontSize from '../CommonSettings/FontSize';
import NumberSetting from '../CommonSettings/NumberSetting';

const Typography = ({
  componentType = 'text',
  defaultAttributes,
  includeLineHeight = true,
  includeTextBackground,
  includeTextColor = true,
  includeFontFamily = true,
  includeFontSize = true,
  item,
  onChange,
}: ComponentSettingsTab & {
  componentType?: string;
  includeLineHeight?: boolean;
  includeTextBackground?: boolean;
  includeTextColor?: boolean;
  includeFontFamily?: boolean;
  includeFontSize?: boolean;
}) => {
  const {
    features: { color },
    hivebrite: { networkColors, networkTheming },
  } = useBuilderConfigContext();
  const colorSettingsProps = {
    color,
    networkColors,
    networkTheming,
  };

  const settingProps = { defaultAttributes, item, onChange };

  return (
    <>
      {includeFontFamily && (
        <FontFamily
          settingKey={`${componentType}FontFamily`}
          title={__('Font family')}
          {...settingProps}
        />
      )}
      {includeFontSize && (
        <FontSize
          settingKey={`${componentType}FontSize`}
          settingLineHeightKey={`${componentType}LineHeight`}
          title={__('Font size')}
          includeLineHeight={includeLineHeight}
          {...settingProps}
        />
      )}
      {includeLineHeight && (
        <NumberSetting
          defaultValue={null}
          settingKey={`${componentType}LineHeight`}
          title={__('Line height')}
          {...settingProps}
        />
      )}
      {includeTextColor && (
        <ColorSetting
          settingKey={`${componentType}Color`}
          title={__('Text color')}
          transparent={false}
          {...settingProps}
          {...colorSettingsProps}
        />
      )}
      {includeTextBackground && (
        <ColorSetting
          settingKey={`${componentType}BackgroundColor`}
          title={__('Background text color')}
          transparent
          {...settingProps}
          {...colorSettingsProps}
        />
      )}
    </>
  );
};

export default Typography;
